/* faire défiler les nouveautés*/
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const slider = document.querySelector('ul.grid');
    
    if (slider) {
      let scrollInterval;
      const scrollSpeed = 3000;
      
      function autoScroll() {
        slider.scrollBy({ left: 400, behavior: 'smooth' });
        
        // Vérifier si on est à la fin
        setTimeout(function() {
          if (slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 50) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }, 800);
      }
      
      scrollInterval = setInterval(autoScroll, scrollSpeed);
      
      // Pause au survol
      slider.addEventListener('mouseenter', function() {
        clearInterval(scrollInterval);
      });
      
      slider.addEventListener('mouseleave', function() {
        scrollInterval = setInterval(autoScroll, scrollSpeed);
      });
    }
  }, 1000);
});
